var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarningCircle = function SvgWarningCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79995 5.5002C9.79995 8.15116 7.65092 10.3002 4.99995 10.3002C2.34898 10.3002 0.199951 8.15116 0.199951 5.5002C0.199951 2.84923 2.34898 0.700195 4.99995 0.700195C7.65092 0.700195 9.79995 2.84923 9.79995 5.5002ZM5.59995 7.9002C5.59995 8.23157 5.33132 8.5002 4.99995 8.5002C4.66858 8.5002 4.39995 8.23157 4.39995 7.9002C4.39995 7.56882 4.66858 7.3002 4.99995 7.3002C5.33132 7.3002 5.59995 7.56882 5.59995 7.9002ZM4.99995 2.5002C4.66858 2.5002 4.39995 2.76882 4.39995 3.1002V5.5002C4.39995 5.83157 4.66858 6.1002 4.99995 6.1002C5.33132 6.1002 5.59995 5.83157 5.59995 5.5002V3.1002C5.59995 2.76882 5.33132 2.5002 4.99995 2.5002Z",
    fill: "#D97706"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-circle.d751b60f.svg";
export { ForwardRef as ReactComponent };